import * as React from 'react';
import {connect} from 'react-redux';
import * as Locale from '../model/locale';
import {Button, DropdownButton, MenuItem} from 'react-bootstrap';
import {LocationFilterLevel, listRegionsByCountry} from '../model/geo';
import {routeActions} from 'redux-simple-router';
import URI from 'urijs';
import * as _ from 'underscore';

export interface LocationFilterProps {
    countries?: any;
    regions?: any;
    filterLevel: LocationFilterLevel;
    textForKey?: Function;
    dispatch?: Function;
    location?: any;
    loading?: boolean;
    stores?: any;
}

// TODO Implement LocationFilterLevel dropdown config and premises.
export class LocationFilter extends React.Component<LocationFilterProps, any> {
    private uri: uri.URI;
    render() {
        let {countries, regions, location, textForKey, loading, stores} = this.props;
        this.uri = URI((location.pathname ? location.pathname : '') + location.search);
        if (loading) {
            return (
                <div className="location-filters">{textForKey(Locale.TEXT_FILTER_LOCATION_LOADING)}</div>
            );
        }
        let {selectedCountry, selectedRegion, store_slug} = this.getSelected(location.query);

        let countryItems = countries.sortedByName.map(c => ({id: c, name: countries.data[c].name}));
        let selectedStore = null;
        let storeList = stores ? stores.results : [];
        // Get right region list.
        let regionList = regions.sortedByName;
        if (store_slug){
            let stores_w_slug: any = _.find(storeList, {slug: store_slug});
            if (stores_w_slug){
                selectedCountry = stores_w_slug.region.country.id;
                selectedRegion = stores_w_slug.region.id;
                selectedStore = stores_w_slug;
                regionList = listRegionsByCountry(regions, selectedCountry);
                storeList = _.filter(storeList, function (s: any) {
                    return s.region.id === selectedRegion;
                });
            }
        } else if (selectedCountry) {
            regionList = listRegionsByCountry(regions, selectedCountry);
            storeList = _.filter(storeList, function (s: any) {
                return selectedRegion ? s.region.id === selectedRegion : s.region.country.id === selectedCountry ;
            });
        } else if (selectedRegion) {
            selectedCountry = regions.data[selectedRegion].country;
            regionList = listRegionsByCountry(regions, selectedCountry);
            storeList = _.filter(storeList, function (s: any) {
                return s.region.id === selectedRegion;
            });
        }

        let regionItems = regionList.map(r => ({id: r, name: regions.data[r].name}));

        // If there is only 1 country, implicitly selected.
        if (countries.sortedByName.length === 1) {
            selectedCountry = countries.sortedByName[0];
        }
        // If there is only 1 region, implicitly selected.
        if (regionList.length === 1) {
            selectedRegion = regionList[0];
        }

        // Get titles
        let countryTitle = textForKey(Locale.TEXT_FILTER_COUNTRY_DEFAULT);
        let regionTitle = textForKey(Locale.TEXT_FILTER_REGION_DEFAULT);
        let storeTitle = textForKey(Locale.TEXT_HEADER_STORE);
        if (selectedCountry) countryTitle = countries.data[selectedCountry].name;
        if (selectedRegion) {
            let regionData = regions.data[selectedRegion];
            regionTitle = regionData.name;
            // Implicit selection of country when we have a region
            if (!selectedCountry) {
                countryTitle = countries.data[regionData.country].name;
            }
        }
        if (selectedStore){
            storeTitle = selectedStore.name;
            if (!selectedRegion){
                regionTitle = selectedStore.region.name
            }
            if (!selectedCountry) {
                countryTitle = selectedStore.region.country.name
            }
        }

        let dropdownData = [
            {items: countryItems, title: countryTitle, id: 'country', onSelect: this.onCountrySelect.bind(this)},
            {items: regionItems, title: regionTitle, id: 'region', onSelect: this.onRegionSelect.bind(this)}
        ];
        if (this.props.stores){
            let storeItems = storeList.map(s => ({id: s.slug, name: s.name}));
            dropdownData = [
                {items: countryItems, title: countryTitle, id: 'country', onSelect: this.onCountrySelect.bind(this)},
                {items: regionItems, title: regionTitle, id: 'region', onSelect: this.onRegionSelect.bind(this)},
                {items: storeItems, title: storeTitle, id: 'store', onSelect: this.onStoreSelect.bind(this)}
            ];
        }
        let dropdowns = dropdownData.map(buildDropdowns);
        return (
            <div className="location-filters">
                {dropdowns}
                <Button bsStyle="btn-reset" onClick={this.onReset.bind(this)}>{textForKey(Locale.TEXT_FILTER_RESET)}</Button>
            </div>
        );
    }

    onCountrySelect(id: number) {
        this.removePage();
        this.removeRegion();
        this.removeStore();
        this.setCountry(id);
        this.replaceUri();
    }

    onRegionSelect(id: number) {
        this.removePage();
        this.removeStore();
        this.setRegion(id);
        this.replaceUri();
    }
    onStoreSelect(store_slug: string){
        this.removePage();
        this.setStore(store_slug);
        this.replaceUri();
    }

    onReset() {
        this.removeAll();
        this.replaceUri();
    }

    private getSelected({selectedCountry, selectedRegion, store_slug}) {
        if (selectedCountry) {
            selectedCountry = parseInt(selectedCountry, 10);
        }
        if (selectedRegion) selectedRegion = parseInt(selectedRegion, 10);
        return {selectedCountry, selectedRegion, store_slug};
    }

    private removePage() {
        this.uri.removeQuery('page');
    }

    private removeRegion() {
        this.uri.removeQuery('selectedRegion');
    }

    private removeCountry() {
        this.uri.removeQuery('selectedCountry');
    }
    private removeStore(){
        this.uri.removeQuery('store_slug');
    }

    private setCountry(id: number) {
        this.uri.setQuery('selectedCountry', id.toString());
    }

    private setRegion(id: number) {
        this.uri.setQuery('selectedRegion', id.toString());
    }

    private setStore(store_slug: string){
        this.uri.setQuery('store_slug', store_slug);
    }

    private replaceUri() {
        this.props.dispatch(routeActions.replace(this.uri.toString()));
    }

    private removeAll() {
        this.removePage();
        this.removeRegion();
        this.removeCountry();
        this.removeStore();
    };
}

function buildFilterItem(item) {
    return (
        <MenuItem eventKey={item.id}>
            {item.name}
        </MenuItem>
    );
}

function buildDropdowns(data) {
    let onSelect = (event, id) => data.onSelect(id);
    return (
        <DropdownButton id={data.id} bsStyle="link" title={data.title} onSelect={onSelect}>
            {data.items.map(buildFilterItem)}
        </DropdownButton>
    );
}

export default connect(
    state => ({
        textForKey: state.data.textForKey,
        countries: state.data.countries,
        regions: state.data.regions,
        loading: state.ui.geo.loading
    })
)(LocationFilter);
